import styled from 'styled-components';
import NavigationLink from 'ggApp/shared/common/NavigationLink';
import FrontshopLink from 'ggApp/shared/containers/FrontshopLink/index';
import { LineItemCard } from 'ggApp/modules/newCheckout/components/LineItemCard';

export const Container = styled.div`
    padding: 8px;
    border-radius: 8px;
    max-height: 100%;
    width: 100%;
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    box-sizing: border-box;
    overflow-y: auto;
`;

export const ContainerHeader = styled.div``;

export const Header = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
`;

export const HeaderTiny = styled.div`
    ${({ theme }) => theme.typography.TinyParagraph};
    align-self: flex-end;
`;

export const HeaderLink = styled(FrontshopLink)`
    ${({ theme }) => theme.typography.TinyParagraph};
    color: ${({ theme }) => theme.colors['Level 4']};
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        color: ${({ theme }) => theme.colors['Level 4']};
    }
`;

export const HeaderContent = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin: 8px 0 16px;
`;

export const HeaderPrice = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 24px;

    &:last-child {
        align-self: flex-end;
    }
`;

export const HeaderList = styled.ul`
    > * {
        margin-bottom: 2px;
        color: ${({ theme }) => theme.colors['Level 4']};

        &:before {
            content: '•';
            margin-right: 4px;
        }
    }
`;

export const ContainerBody = styled.div`
    > *:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const AddProduct = styled(NavigationLink)`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 16px;
    width: 100%;
    height: 52px;
    background-color: ${({ theme }) => theme.colors.secondaryBackground};
    border-radius: 8px;
    opacity: ${({ isDisabled }) => isDisabled && `0.4`};
    cursor: ${({ isDisabled }) => (isDisabled ? `not-allowed` : `pointer`)};

    &:not(:last-child) {
        margin-bottom: 8px;
    }

    * {
        color: ${({ theme }) => theme.colors.secondary};
    }

    > svg {
        margin-right: 8px;
        width: 20px;
        height: 20px;

        * {
            fill: ${({ theme }) => theme.colors.secondary};
        }
    }
`;

export const ProductCard = styled(LineItemCard)`
    margin-bottom: 8px;
    padding: 16px;
    align-items: center;
`;
